"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
exports.drupalCookie = function () {
    var windowHook = document.getElementById('overflow');
    var lang = document.documentElement.getAttribute('lang');
    var cookieExpires = 365;
    var cookieTextPL = {
        text: 'Do poprawnego działania, ta strona korzysta z plików cookies.',
        findmore: { text: 'Dowiedz się więcej', link: '/pl/polityka-prywatnosci' },
        button_accept: 'Akceptuję'
    };
    var cookieTextEN = {
        text: 'This site uses cookies. If you continue browsing, you agree to the use of cookies. More information can be found in our',
        findmore: { text: 'Privacy policy', link: '/privacy-policy' },
        button_accept: 'I&nbsp;agree'
    };
    var cookieTextRO = {
        text: 'This site uses cookies. If you continue browsing, you agree to the use of cookies. More information can be found in our',
        findmore: { text: 'Privacy policy', link: '/ro/privacy-policy' },
        button_accept: 'De&nbsp;acord'
    };
    var cookieText;
    cookieText = lang === 'pl' ? cookieTextPL : lang === 'ro' ? cookieTextRO : cookieTextEN;
    var cookieAccepted = js_cookie_1.default.get('breakpoint_cookie_accept') == 'true';
    if (!cookieAccepted) {
        var html = "\n      <div class=\"cookies\">\n        <div class=\"container\">\n          <div class=\"cookies__content\">\n            <p class=\"is-white is-marginless is-light\">" + cookieText.text + " <a href=\"" + cookieText.findmore.link + "\">" + cookieText.findmore.text + "</a></p>\n          </div>\n          <div class=\"cookies__accept\">\n            <button id=\"accept\" class=\"button button--cookiesaccept is-white\"> " + cookieText.button_accept + "</button>\n          </div>\n        </div>\n      </div>";
        windowHook.insertAdjacentHTML('afterend', html);
        var buttonAccept_1 = document.getElementById('accept');
        var accept_1 = function () {
            js_cookie_1.default.set('breakpoint_cookie_accept', 'true', { expires: cookieExpires });
            document.querySelector('.cookies').classList.add('cookies--hide');
            buttonAccept_1.removeEventListener('click', accept_1);
        };
        buttonAccept_1.addEventListener('click', accept_1);
    }
};
